import { render } from "./registrationDepartmentDetails.vue?vue&type=template&id=7fd116c2&scoped=true"
import script from "./registrationDepartmentDetails.vue?vue&type=script&lang=js"
export * from "./registrationDepartmentDetails.vue?vue&type=script&lang=js"

import "./registrationDepartmentDetails.vue?vue&type=style&index=0&id=7fd116c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd116c2"]])

export default __exports__